module.exports = __webpack_public_path__ + "img/sugar_hanger_3.53b2363d.jpg";